<div class="dashboard-header">
  <div class="dashboard-breadcrumb-wrapper">
    <nrwl-breadcrumb></nrwl-breadcrumb>
  </div>
  <div class="dashboard-actions-wrapper">
    <test-info-actions
      [testInfoValue]="testInfoValue"
      [testConfig]="testConfig"
      *ngIf="testInfoValue.isVisible"
    ></test-info-actions>
    <span class="dashboard-url" *ngIf="testInfoValue.subText">{{ testInfoValue.subText }}</span>
  </div>
  <div class="dashboard-timepicker-wrapper" *ngIf="timePickerValue.isVisible">
    <time-picker *ngIf="!timePickerValue.isFixed"></time-picker>
    <selected-time-range *ngIf="timePickerValue.isFixed"></selected-time-range>
  </div>
</div>
